<div (click)="maybeOpenPopover($event)" class="alc-ellipsis">{{ displayedValue }}</div>
<!-- classes are used to reproduce the apparence of the clear button in a ion-input -->
<button
  *ngIf="displayedValue && !disabled"
  aria-label="reset"
  type="button"
  class="input-clear-icon sc-ion-input-md"
  (click)="clear()">
  <ion-icon class="sc-ion-input-md" name="close"></ion-icon>
</button>
